/* eslint-disable */
import { useStore } from '@/store'
import PermissionChecker from '@/security/permission-checker';

export default {
  async beforeRouteEnter(to, from, next) {
    if (!to.meta) {
      next()
      return
    }

    const store = useStore()
    let currentUser = localStorage.getItem('currentUser')
    if (currentUser) {
      await store.dispatch('auth/doWaitUntilInit')
    }
    if (to.meta.auth) {
      if (!store.getters['auth/signedIn']) {
        next({ path: '/auth/login' })
        return
      }
      if (
        to.path !== '/auth/empty-permissions' &&
        store.getters['auth/currentUser'].emailVerified &&
        // !store.getters['auth/roles'].length
        !(
          (store.getters['auth/role'] === 'admin' ||
            store.getters['auth/role'] === 'owner') &&
          store.getters['auth/currentUser'].isEnabled
        )
      ) {
        next({ path: '/auth/empty-permissions' })
        return
      }
    }

    if (to.meta.unauth) {
      if (store.getters['auth/signedIn']) {
        next({ path: '/' })
        return
      }
    }

    if (to.meta.notEmptyPermissions) {
      if (
        store.getters['auth/signedIn'] &&
        store.getters['auth/roles'].length
      ) {
        next('/')
      } else {
        next()
      }
    }

    if (to.meta.permission) {
      if (
        new PermissionChecker(store.getters['auth/currentUser']).match(
          to.meta.permission
        )
      ) {
        next()
      } else {
        next('/403')
      }
    }

    next()
  }
}
